import { Button, InputWraper, useForm } from 'modules';
import React, { FC } from 'react';
import * as Yup from 'yup';

import { InputSelect, InputTextArea } from '../../../components';
import TableElectricBillList from '../components/tableElectricBillList';
import transferWrapper from '../components/wrapper';

const ElectricBill: FC = transferWrapper(() => {
  const { getInputProps, handleSubmit } = useForm({
    structure: [
      {
        name: 'electricCategory',
        validate: Yup.string().required('Must be provided'),
      },
      {
        name: 'customerCode',
        validate: Yup.string().required('Must be provided'),
      },
    ],
    onSubmit: async (values: any) => {
      return values;
    },
  });

  return (
    <>
      <div className='container-fluid electric-bill-access'>
        <div className='row'>
          <div className='col-lg-4 col-12'>
            <InputWraper
              label={'Điện lực'}
              inputProps={getInputProps('electricCategory')}
              renderInput={(props) => (
                <InputSelect
                  {...props}
                  options={[
                    { label: 'PB0306 - Lâm Hà', value: 'PB0306' },
                    { label: 'PB0307 - Thái Hà', value: 'PB0307' },
                  ]}
                />
              )}
            />
          </div>

          <div className='col-lg-4 col-12'>
            <InputWraper
              label={'Mã khách hàng'}
              inputProps={getInputProps('customerCode')}
              component={InputTextArea}
            />
          </div>
        </div>
        <div className='electric-bill-access__action'>
          <Button
            label={'Truy vấn'}
            type='submit'
            buttonType='success'
            // isLoading={isSubmitting}
            onClick={handleSubmit}
          />
        </div>
      </div>

      <TableElectricBillList />
    </>
  );
});

export default ElectricBill;
